import React from 'react';
import { Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import DownloadLink from './DownloadLink';

const PdfViewer = ({ documentUrl }) => {
  return (
    <div style={{ height: '100vh' }}>
      <DownloadLink
        fileUrl={documentUrl}
        fileName="document.pdf"
        title={<Trans ns="commerce">PDF download</Trans>}
      />
      <embed
        src={documentUrl}
        type="application/pdf"
        width="100%"
        height="100%"
      />
    </div>
  );
};

PdfViewer.propTypes = {
  documentUrl: PropTypes.string.isRequired
};

export default PdfViewer;
